import { Observable, of } from 'rxjs';
import { DropdownAction } from '../../tool/action/dropdown-action';
import { StandardAction } from '../../tool/action/standard-action';

export class DropdownActionBuilder {
  readonly _dropdownAction: DropdownAction;

  constructor(name: string, icon: string) {
    this._dropdownAction = new DropdownAction(name, icon, of([]));
    return this;
  }

  public setEnable(enable: boolean): DropdownActionBuilder {
    this._dropdownAction.enable = enable;
    return this;
  }

  public enable(): DropdownActionBuilder {
    this._dropdownAction.enable = true;
    return this;
  }

  public disable(): DropdownActionBuilder {
    this._dropdownAction.enable = false;
    return this;
  }

  public displayText(): DropdownActionBuilder {
    this._dropdownAction.showText = true;
    return this;
  }

  public hideText(): DropdownActionBuilder {
    this._dropdownAction.showText = false;
    return this;
  }

  public setText(text: string): DropdownActionBuilder {
    this._dropdownAction.text = text;
    return this;
  }

  public setTooltip(tooltip: string): DropdownActionBuilder {
    this._dropdownAction.tooltip = tooltip;
    return this;
  }

  public setAlign(align: 'left' | 'center' | 'right'): DropdownActionBuilder {
    this._dropdownAction.align = align;
    return this;
  }

  public setFontAwesome(
    fontAwesome: 'fal' | 'fas' | 'far' | 'fad' | 'fat',
  ): DropdownActionBuilder {
    this._dropdownAction.fontAwesome = fontAwesome;
    return this;
  }

  public setIsHighlighted(value: boolean): DropdownActionBuilder {
    this._dropdownAction.isHighlighted = value;
    return this;
  }

  public setHighlightedColor(value: string): DropdownActionBuilder {
    this._dropdownAction.highlightedColor = value;
    return this;
  }

  public setHighlightedBackgroundColor(value: string): DropdownActionBuilder {
    this._dropdownAction.highlightedBackgroundColor = value;
    return this;
  }

  public setBold(value: boolean): DropdownActionBuilder {
    this._dropdownAction.bold = value;
    return this;
  }

  public setIconColor(color: string): DropdownActionBuilder {
    this._dropdownAction.iconColor = color;
    return this;
  }

  public setIsOpen(isOpen: boolean): DropdownActionBuilder {
    this._dropdownAction.isOpen = isOpen;
    return this;
  }

  public open(): DropdownActionBuilder {
    this._dropdownAction.isOpen = true;
    return this;
  }

  public close(): DropdownActionBuilder {
    this._dropdownAction.isOpen = false;
    return this;
  }

  public setIsGroup(isGroup: boolean): DropdownActionBuilder {
    this._dropdownAction.isGroup = isGroup;
    return this;
  }

  public group(): DropdownActionBuilder {
    this._dropdownAction.isGroup = true;
    return this;
  }

  public ungroup(): DropdownActionBuilder {
    this._dropdownAction.isGroup = false;
    return this;
  }

  public setIsMultiple(isMultiple: boolean): DropdownActionBuilder {
    this._dropdownAction.isMultiple = isMultiple;
    return this;
  }

  public multiple(): DropdownActionBuilder {
    this._dropdownAction.isMultiple = true;
    return this;
  }

  public single(): DropdownActionBuilder {
    this._dropdownAction.isMultiple = false;
    return this;
  }

  public setWithSearch(withSearch: boolean): DropdownActionBuilder {
    this._dropdownAction.withSearch = withSearch;
    return this;
  }

  public setDatasource(
    datasource$: Observable<StandardAction[]>,
  ): DropdownActionBuilder {
    this._dropdownAction.datasource$ = datasource$;
    return this;
  }

  build(): DropdownAction {
    return this._dropdownAction;
  }
}
